import React, {Component} from 'react';
import {connect} from 'react-redux';
import Tooltip from 'components/atoms/tooltip';

class ConfirmationTooltip extends Component {
    render() {
        const {
            teams: {data: teams},
            teamName,
        } = this.props;

        if (!teams.hasOwnProperty(teamName) || !teams[teamName].hasOwnProperty('confirmed')) {
            return null;
        }

        if (teams[teamName].confirmed) {
            return <Tooltip iconClassName={'fa fa-check'} subject={'Lineup Confirmed'} />;
        }

        return <Tooltip iconClassName={'fa fa-question'} subject={'Lineup Not Confirmed'} />;
    }
}

function mapStatesToProps(state) {
    const {teams} = state.playersData;
    return {
        teams,
    };
}

export default connect(mapStatesToProps)(ConfirmationTooltip);
